import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="docs--subnav"
export default class extends Controller {
  static targets = ["topButton"]

  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll)
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    const isVisible = window.scrollY > 200
    this.topButtonTarget.classList.toggle("docs-subnav__top--visible", isVisible)
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
